require('./build.css')
class samplemodule
{
	constructor()
	{
		console.log('es6 example');
	}
}
export default samplemodule;